@if ({
  isSosh: isSoshFromAbstractAppComponent$ | async,
  isSmartBannerDisplayed: isSmartBannerDisplayed$ | async,
  navConfig: navConfig$ | async,
  isXlScreen: isXlScreen$ | async,
  }; as model) {
  <div [ngClass]="model.isSosh ? 'ecm-theme-sosh' : 'ecm-theme-orange'">
    @if (model.isSmartBannerDisplayed) {
      <ecm-smartbanner></ecm-smartbanner>
    }
    @if (this.showMenuBar && this.isBrandResolved) {
      <ecm-service-header
        [isSoshMenu]="this.isSoshMenu"
      ></ecm-service-header>
    }
    <main role="main">
      <ecm-layout-container
        [lateralMenu]="model.navConfig.lateralMenu"
        [carrousel]="model.navConfig.carrousel"
        [isXlScreen]="model.isXlScreen"
        >
        <router-outlet></router-outlet>
      </ecm-layout-container>
    </main>
  </div>
}
